import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  p {
    text-align: center;
    font-size: ${({ theme }) => theme.fontSize.x3};
    font-weight: 500;
    font-family: ${({ theme }) => theme.fontFamily.inter};
  }
`
